export default __webpack_public_path__ + "static/media/IMG-20220611-WA0180.c836f0df.jpg";